var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660 2560 l0 -2560 1900 0 1900 0 0 2560 0 2560 -1900 0 -1900 0 0 -2560z m3500 0 l0 -2260 -1600 0 -1600 0 0 2260 0 2260 1600 0 1600 0 0 -2260z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082 4300 c-167 -39 -207 -262 -64 -361 52 -35 143 -38 202 -7 139 75 137 280 -5 350 -40 21 -93 28 -133 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2452 3777 l-532 -532 103 -103 c56 -56 107 -102 112 -102 6 0 249 238 540 530 l530 530 -105 105 c-58 58 -107 105 -110 105 -3 0 -245 -240 -538 -533z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2925 3425 c-54 -19 -111 -84 -123 -141 -26 -122 55 -233 178 -242 67 -4 129 24 174 81 60 75 42 212 -35 269 -64 48 -123 58 -194 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500 2370 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500 1630 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500 890 l0 -150 1060 0 1060 0 0 150 0 150 -1060 0 -1060 0 0 -150z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.d897f26dc8a7e2d2b246673c50af5af0.svg";
export { ForwardRef as ReactComponent };